module.exports = __webpack_public_path__ + "img/sample-02.b10f46ac.jpg";